import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { PencilLine, AlignVerticalJustifyEnd, Notebook } from "lucide-react";
import Sidebar from "../components/sidebar";
import { API_BASE } from "../utils/draftutils"; // <<< URL base backend

export default function MenuFruitore({ role, username }) {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { name: "Visualizza servizi", path: "visualizza-gerarchie", icon: <AlignVerticalJustifyEnd size={20} /> },
    { name: "Crea proposta", path: "crea-proposta", icon: <PencilLine size={20} /> },
    { name: "Visualizza proposte", path: "visualizza-proposte", icon: <Notebook size={20} /> },
  ];

  const handleLogout = async () => {
    try {
      await fetch(`${API_BASE}/api/auth/logout`, {
        method: "POST",
        credentials: "include",
      });
      navigate("/");
    } catch (err) {
      console.error("Errore durante il logout", err);
    }
  };

  return (
    <div className="app">
      <Sidebar
        role={role}
        menuItems={menuItems}
        handleLogout={handleLogout}
        username={username}
      />
      <main className="content bg-body-tertiary">
        {location.pathname === "/menufruitore" ? (
          <div className="d-flex align-items-center justify-content-center h-100">
            <p className="text-muted" style={{ fontSize: "1.4rem" }}>
              Seleziona una funzione dal menu per continuare
            </p>
          </div>
        ) : (
          <Outlet context={{ username }} />
        )}
      </main>
    </div>
  );
}
